import { Text } from 'slate';

function nodeIsEmptyText(node) {
  return Text.isText(node) && node.text === '';
}
function elementIsEmpty(element) {
  return element.children.every(nodeIsEmptyText);
}

export { elementIsEmpty };
